export default "__VITE_ASSET__f3880c81__"